/* eslint-disable no-unused-vars */
/* eslint-disable react/no-this-in-sfc */
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { useTranslation } from 'react-i18next';

/**
 * This component is a stylized chart to display semi circle data.
 * @param {Object with array: ethnicities} data
 */
export default function SemiCircleChart({ data }) {
  SemiCircleChart.defaultProps = {
    data: undefined,
  };

  SemiCircleChart.propTypes = {
    data: PropTypes.shape(),
  };

  /**
   * The component will be rendered only if there are data.
   */
  if (!data) {
    return null;
  }

  const theme = useTheme();
  const { t } = useTranslation();

  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      padding: 0,
      height: 300,
      spacing: [10, 10, 15, 0],
      backgroundColor: 'transparent',
    },
    title: {
      text: `${t(`dataType_${data.dataType}`)} ${t(
        `semiCircleChart_posTitle`
      )}`,
      align: 'left',
      style: {
        color: theme.colorText,
        fontFamily: 'roboto',
        fontWeight: 400,
        fontSize: 16,
      },
    },
    tooltip: {
      formatter() {
        return (
          `<b>${this.point.name}</b><br/>` +
          ` ${t(`dataType_${data.dataType}`)}: <b> ${t('general_number', {
            value: this.point.y,
          })} (${Highcharts.numberFormat(
            Math.abs(this.point.percentage),
            2
          )}%)</b>`
        );
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            borderWidth: 0,
            color: 'white',
          },
        },
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
        size: '100%',
        borderWidth: 0,
        showInLegend: true,
      },
    },
    legend: {
      itemStyle: {
        color: theme.colorText,
      },
    },
    colors: theme.semiCircleVaccinationPainting.colors,
    series: [
      {
        type: 'pie',
        name: t(`dataType_${data.dataType}`),
        innerSize: '50%',
        data: data.ethnicities,
      },
    ],
    navigation: {
      menuStyle: {
        background: theme.colorBackground,
        border: 'none',
        boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.2)',
      },
      menuItemStyle: { color: theme.colorText },
      menuItemHoverStyle: { background: theme.colorTertiary },
    },
    lang: {
      contextButtonTitle: 'Exportar gráfico',
    },
    exporting: {
      chartOptions: {
        chart: {
          style: {
            backgroundColor: theme.colorBackground,
          },
        },
      },
      menuItemDefinitions: {
        downloadPNG: { text: `${t('charts_printButton')} .png` },
        downloadJPEG: { text: `${t('charts_printButton')} .jpeg` },
        downloadPDF: { text: `${t('charts_printButton')} .pdf` },
        downloadSVG: { text: `${t('charts_printButton')} .svg` },
      },
      buttons: {
        contextButton: {
          symbolFill: theme.colorText,
          symbolStroke: theme.colorText,
          theme: {
            fill: 'transparent',
            states: {
              hover: {
                fill: theme.colorSeparator,
              },
              select: {
                fill: theme.colorSeparator,
              },
            },
          },
          menuItems: [
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
          ],
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
